import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const formatDateToET = (date: Date): string => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const dateStr = formatInTimeZone(date, timeZone, 'MMM d, yyyy');
  const timeStr = formatInTimeZone(date, timeZone, 'h:mma')
    .replace('AM', 'am')
    .replace('PM', 'pm');

  const timeZoneName =
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    })
      .formatToParts(date)
      .find(part => part.type === 'timeZoneName')?.value ?? '';

  return `${dateStr} · ${timeStr} ${timeZoneName}`;
};

export const formatDateTime = (date: Date): string => {
  return format(date, 'MMM d, h:mma').replace('AM', 'am').replace('PM', 'pm');
};

export const formatDate = (date: Date): string => {
  return format(date, 'MMM d, yyyy, h:mma')
    .replace('AM', 'am')
    .replace('PM', 'pm');
};

export const formatTimeOnly = (date: Date): string => {
  return format(date, 'h:mma').replace('AM', 'am').replace('PM', 'pm');
};

export const formatMonthDay = (date: Date): string => {
  return format(date, 'MMM d');
};
